import { getAccessScopeId } from "@lib/access/access";
import { i18n } from "@lib/i18n";
import { clearLogas } from "@lib/utils/clearLogas";
import { rootRoute } from "@routes";
import { allowInsider, redirectToAccessFallback } from "@routes/authorization";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

export const logAsRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: `side-admin`,
    component: lazyRouteComponent(() => import("@pages/logas"), "LogasPage"),
    beforeLoad: async () => {
        const accountId = getAccessScopeId("account");
        const networkId = getAccessScopeId("network");
        clearLogas();
        const allowed = await allowInsider();
        if (!allowed) {
            // A rejected visit must keep the user's usable scope for the fallback decision.
            if (accountId) localStorage.setItem("side_team_activeOrganisationId", accountId);
            if (networkId) localStorage.setItem("side_team_groupId", networkId);
            redirectToAccessFallback();
        }

        return { getTitle: () => i18n.doc_title_logas() };
    },
});
